import { useSelector } from 'react-redux'
import { ApplicationState } from '@/state/root.models'
import useForm from '@/hooks/form/use-form.hook'

import { enableSchema } from '../components/schema'
import { enableValidator } from '../components/validator'

const useEnable = () => {
  const { currentBonus } = useSelector(
    ({ bonusEngine }: ApplicationState) => bonusEngine,
  )

  const { state, handleOnChange, disable, setFormValues, setDisable } = useForm(
    enableSchema,
    enableValidator,
    () => {},
  )

  const setCurrentEnable = () => {
    setFormValues({
      isActive: {
        value: currentBonus.isActive,
        error: '',
      },
      // isMakeUpRule: {
      //   value: currentBonus.isMakeUpRule,
      //   error: '',
      // },
    })
    setDisable(false)
  }

  return {
    enable: { state, handleOnChange, disable, setFormValues },
    setCurrentEnable,
  }
}

export default useEnable
